import * as station from '../actions/stationQueryAction'

const initialState = {
    history: [],
    error: undefined,
    status: 0
};

const stationHistory = (state = initialState, action) => {
    switch (action.type) {
        case station.STATION_HISTORY_REQUEST:
            return ({
                ...state,
                status: 1
            });
        case station.STATION_HISTORY_SUCCESS:
            return ({
                ...action.data,
                error: undefined,
                status: 2
            });
        case station.STATION_HISTORY_FAILURE:
            return ({
                history: [],
                error: action.error,
                status: 3
            });
        default:
            return state;
    };
}

export default stationHistory;
